import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  user: {},
  ready: false,
  isAuthenticated: false,
  isImpersonated: false,
  isExtraVisibilityPaymentVisible: false,
  isAccessOverridable: false,
  tasksToComplete: null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
